<template>
  <a-layout-content>
    <a-form layout="inline">
      <a-form-item label="会员名称">
        <a-input v-model="input.Uid" />
      </a-form-item>
      <a-form-item label="会员IP">
        <a-input v-model="input.IP" />
      </a-form-item>
      <a-form-item label="时间范围">
        <a-range-picker
          :ranges="dataRange"
          :default-value="[moment().startOf('day'), moment().endOf('day')]"
          show-time
          :format="dateFormat"
          @change="onChange"
        />
      </a-form-item>
      <a-form-item>
        <a-button type="primary" @click="query()"
          ><a-icon type="search"
        /></a-button>
      </a-form-item>
    </a-form>

    <div class="body-nest">
      <a-table
        bordered
        row-key="ID"
        size="middle"
        :columns="columns"
        :data-source="datarow"
        :pagination="pagination"
        @change="changepage"
      >
        <template slot="title">
          <a-row>
            <a-col style="float: right">
              <a href="javascript:;" @click="AllExport()">
                <a-icon type="file-excel" style="font-size: 22px"></a-icon>
                <span style="font-size: 15px">导出数据</span>
              </a>
            </a-col>
          </a-row>
        </template>
      </a-table>
    </div>
  </a-layout-content>
</template>
<script>
let datarow = [];
import XLSX from "xlsx";
import moment from "moment";
import { jsonExportSheet } from "../../js/xlsxTool";

export default {
  data() {
    return {
      dataRange,
      //------table --------
      columns: IninTable(),
      datarow,
      pagination: {
        total: 0,
        pageindex: 1,
        pagesize: 10,
        showTotal: (total) => `共 ${total} 条`,
        showSizeChanger: true, // 可以改变每页个数
        pageSizeOptions: ["10", "20", "30", "40"],
        onShowSizeChange: (current, pageSize) => (this.pageSize = pageSize),
      },
      //--------------------
      input: {
        Uid: "",
        IP: "",
        StarTime: "",
        EndTime: "",
      },
      dateFormat: "YYYY-MM-DD HH:mm:ss",
    };
  },
  methods: {
    moment,
    query() {
      if ((this.input.StarTime === "")) {
        this.$message.warning("请选择查询开始时间!");
        return false;
      }
      if ((this.input.EndTime === "")) {
        this.$message.warning("请选择查询结束时间!");
        return false;
      }

      let params = {
        Uid: this.input.Uid,
        IP: this.input.IP,
        StarTime: this.input.StarTime,
        EndTime: this.input.EndTime,
        pageindex: this.pagination.pageindex,
        pagesize: this.pagination.pagesize,
      };

      this.axios.post("/mgruser/getuserloginrecordlist", params).then((res) => {
        this.datarow = res.data;
        this.pagination.total = res.total;
      });
    },
    // 查询时间绑定
    onChange(value, dateString) {
      this.input.StarTime = dateString[0];
      this.input.EndTime = dateString[1];
    },
    //翻页
    changepage(e) {
      this.pagination.pageindex = e.current;
      this.pagination.pagesize = e.pageSize;
      this.query();
    },
    // 导出所有
    AllExport() {
      const _this = this;
      this.$confirm({
        title: "导出",
        content: "确定要导出筛选数据吗？",
        onOk() {
          _this.DataExport({
            Uid: _this.input.Uid,
            IP: _this.input.IP,
            StarTime: _this.input.StarTime,
            EndTime: _this.input.EndTime,
            pageindex: 0,
            pagesize: 0,
          });
        },
      });
    },
    // 数据导出
    DataExport(data) {
      this.axios.post("/mgruser/exportuserloginrecord", data).then((res) => {
        if (res.data) {
          if (res.data.length > 0) {
            var sheet = XLSX.utils.json_to_sheet(res.data);
            sheet["A1"].v = "#";
            sheet["B1"].v = "会员账号";
            sheet["C1"].v = "登入IP";
            sheet["D1"].v = "登入时间";
            jsonExportSheet(sheet, this.moment().format("YYYYMMDDhhmmss"));
          } else {
            this.$message.warning("无数据导出!");
          }
        }
      });
    },
  },
  created() {
    // 初始化时间
    this.input.StarTime = moment().startOf("day").format(this.dateFormat);
    this.input.EndTime = moment().endOf("day").format(this.dateFormat);
    this.query();
  },
};

let dataRange = {
  今天: [moment().startOf("day"), moment()],
  昨天: [
    moment().startOf("day").subtract(1, "days"),
    moment().startOf("day").subtract(1, "days"),
  ],
  本周: [moment().startOf("week"), moment().endOf("week")],
  本月: [moment().startOf("month"), moment().endOf("month")],
};

const IninTable = function IninTable() {
  var header = [];
  header.push({ title: "#", align: "center", width: 50, dataIndex: "ID" });
  header.push({ title: "会员账号", align: "center", dataIndex: "Uid" });
  header.push({ title: "登入IP", align: "center", dataIndex: "IP" });
  header.push({
    title: "登入时间",
    align: "center",
    //sorter: (a, b) =>
    //new Date(a.Time.replace(/[\u4e00-\u9fa5]/g, "")).getTime() -
    //new Date(b.Time.replace(/[\u4e00-\u9fa5]/g, "")).getTime(),
    dataIndex: "Time",
  });
  return header;
};
</script>

<style>
.clearline {
  border-top: solid #acc0d8 1px;
  margin: 10px 0;
}
</style>


// WEBPACK FOOTER //
// src/components/adminmanage/userloginrecord.vue